import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const BrandsTypes = ({ form, onChange, brandsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Марка ТС">
      {getFieldDecorator('brand_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите марку ТС"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          onChange={onChange}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {brandsTypes &&
            brandsTypes.map(type => (
              <Option
                key={type.brandKey}
                value={type.brandKey}
                label={type.brandName}
              >
                {type.brandName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(BrandsTypes, ['brandsTypes']);
